import {
  getEnableMembers,
  saveAddGroup,
  deleteGroup,
  editGroup,
  saveGroupLeader,
  getGroupMembers,
  getGroupSetPermissionDatas,
  saveGroupSetPermissionDatas
} from '@/services/team'
import i18n from '@/lib/language'
const groupSetRemainData = [
  {
    name: i18n.t('message["299"]'),
    value: '1'
  },
  {
    name: i18n.t('message["714"]'),
    value: '2'
  },
  {
    name: i18n.t('message["3"]'),
    value: '3'
  },
  {
    name: i18n.t('message["1674"]'),
    value: '4'
  }
]
export default {
  namespaced: true,
  state: {
    groupSetRemainData,
    divideObj: {
      divide_type: 1,
      divide_desc: []
    },
    groupFinalLoading: false, // 小组最终保存loading
    editGroupSet: { groupid: '', leader: [], divide_type: 1, divide_desc: [], groupname: '' }, // 小组设置数据
    groupEditLimitVisible: false, // 编辑额度
    isDisplayRemain: 0, // 编辑小组是否显示分配信息
    addGroupList: [], // 添加小组 待选小组成员列表
    addGroupVisible: false, // 添加小组Dialog状态
    addGroupLoading: false, // 添加小组Dialog 保存Loading状态,
    groupPermissionList: [], // 小组设置权限列表
    groupSetVisible: false, // 小组设置状态
    groupMemberLeaderList: [], // 获取小组成员组长数据
    groupMemberList: [], // 获取小组成员数据
    groupLeaderEditVisible: false, // 组长编辑dialog
    groupLeaderEditSaveLoading: false // 组长编辑dialog保存loading
  },
  mutations: {
    setGroupLeaderEditSaveLoading (state, data) {
      state.groupLeaderEditSaveLoading = data
    },
    setEditGroupSet (state, data) {
      state.editGroupSet = data
    },
    setDivideObj (state, data) {
      state.divideObj = data
    },
    setGroupFinalLoading (state, data) {
      state.groupFinalLoading = data
    },
    setGroupEditLimitVisible (state, data) {
      state.groupEditLimitVisible = data
    },
    setIsDisplayRemain (state, data) {
      state.isDisplayRemain = data
    },
    setGroupLeaderEditVisible (state, data) {
      state.groupLeaderEditVisible = data
    },
    // 设置待选小组列表数据
    setAddGroupList (state, data) {
      state.addGroupList = data
    },
    // 设置待选小组列表数据
    setGroupMemberList (state, data) {
      state.groupMemberList = data
    },
    // 设置待选小组列表数据
    setGroupMemberLeaderList (state, data) {
      state.groupMemberLeaderList = data
    },
    // 设置添加小组Dialog状态
    setAddGroupVisible (state, data) {
      state.addGroupVisible = data
    },
    // 设置添加小组Loading状态
    setAddGroupLoading (state, type) {
      state.addGroupLoading = type
    },
    // 设置添加小组Loading状态
    setGroupSetVisible (state, type) {
      state.groupSetVisible = type
    },
    // 小组设置权限列表
    setGroupPermissionList (state, type) {
      state.groupPermissionList = type
    }
  },
  actions: {
    changeEditGroupSet ({ commit }, data) {
      commit('setEditGroupSet', data)
      commit('setGroupEditLimitVisible', false)
      commit('setGroupLeaderEditVisible', false)
      commit('setGroupLeaderEditSaveLoading', false)
    },
    changeGroupFinalLoading ({ commit }, data) {
      commit('setGroupFinalLoading', data)
    },
    changeGroupLeaderEditSaveLoading ({ commit }, data) {
      commit('setGroupLeaderEditSaveLoading', data)
    },
    changeGroupEditLimitVisible ({ commit }, data) {
      commit('setGroupEditLimitVisible', data)
    },
    changeGroupLeaderEditVisible ({ commit }, data) {
      commit('setGroupLeaderEditVisible', data)
    },
    // 改变添加小组Dialog状态方法
    changAddGroupVisible ({ commit }, data) {
      commit('setAddGroupVisible', data)
    },
    // 改变添加小组Loading状态方法
    changAddGroupLoading ({ commit }, data) {
      commit('setAddGroupLoading', data)
    },
    // 改变添加成员Loading状态方法
    changAddMemberLoading ({ commit }, data) {
      commit('setAddMemberLoading', data)
    },
    // 改变小组设置状态
    changeGroupSetVisible ({ commit }, data) {
      commit('setGroupSetVisible', data)
    },
    // 添加小组获取可选择人员列表
    async fetchGetEnableMembers ({ rootState, commit }) {
      const roleArr = rootState.team.manage.selectTreenDataKey.split('-')
      const chain = await getEnableMembers()
        .onSuccess(payload => {
          commit('setAddGroupList', payload.list)
        })
        .params({
          roleid: roleArr[1]
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 保存小组
    async fetchSaveGroup ({ commit, rootState, dispatch }, data) {
      const { groupname, groupMember } = data
      const roleArr = rootState.team.manage.selectTreenDataKey.split('-')
      const chain = await saveAddGroup()
        .onNetSuccess(raw => {
          commit('setAddGroupLoading', false)
          if (raw.data.error === 0) {
            commit('setAddGroupVisible', false)
            dispatch(
              'team/manage/fetchTeamOrganizationDatas',
              { roleid: roleArr[1], roleName: roleArr[0], groupname },
              { root: true }
            )
          }
        })
        .params({
          groupname,
          userid: groupMember.filter(item => item * 1),
          roleid: roleArr[1]
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 删除小组
    async fetchDeleteGroup ({ dispatch }, data) {
      const chain = await deleteGroup()
        // .onSuccess((raw, res) => {
        //   dispatch('team/manage/fetchTeamOrganizationDatas', {}, { root: true })
        // })
        .params({
          ...data
        })
        .config({
          tip: true
        })
        // .fetch()
      return chain
    },
    // 编辑小组保存
    async fetchEditGroup ({ dispatch }, data) {
      const chain = await editGroup()
        .onSuccess(payload => {
          dispatch(
            'team/manage/fetchTeamOrganizationDatas',
            { name: data.groupname, groupid: data.groupid },
            { root: true }
          )
        })
        .params({
          ...data
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 获取小组设置权限列表
    async fetchGetGroupSetPermissionDatas ({ commit }, params) {
      const chain = await getGroupSetPermissionDatas()
        .onSuccess(payload => {
          commit('setGroupPermissionList', payload)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取小组设置权限列表提交
    async fetchSubmitGroupSetPermissionDatas ({ commit }, params) {
      const chain = await saveGroupSetPermissionDatas()
        .onSuccess(payload => {
          commit('setGroupSetVisible', false)
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 小组组长编辑设置提交
    async fetchSaveGroupLeader ({ commit, dispatch }, params) {
      const chain = await saveGroupLeader()
        .onSuccess(payload => {
          commit('setGroupFinalLoading', false)
          commit('setGroupLeaderEditSaveLoading', false)
          commit('setGroupSetVisible', false)
          dispatch('fetchGetGroupMembers', { groupid: params.groupid })
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })

      await chain.fetch()
      return chain
    },
    // 获取小组组长数据
    async fetchGetGroupMembers ({ commit }, params) {
      const chain = await getGroupMembers()
        .onSuccess(payload => {
          commit('setDivideObj', {
            divide_type: payload.divide_type,
            divide_desc: payload.divide_desc
          })
          commit('setIsDisplayRemain', payload.isdisplay)
          commit('setGroupMemberList', payload.member.list)
          commit('setGroupMemberLeaderList', payload.leader)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    }
  }
}
